/*
  Nice Candy: Feedback nach "In den Warenkorb".
  1. Button: Theme zeigt den Lade-Kreis, danach setzen wir für 1,5 Sekunden einen Haken.
  2. Fly-to-Cart: Eine kleine Kopie des Produktbilds hebt kurz an, steigt im Bogen langsam auf,
     beschleunigt und "knallt" in das Warenkorb-Symbol. Das Symbol federt, ein Ring mit Funken platzt auf.
  3. Zähler: wird sofort aus /cart.js gesetzt (das Theme selbst aktualisiert erst nach einer Sekunde).
  4. In der offenen Warenkorbschublade (und auf der Warenkorbseite) fliegt das Bild stattdessen auf den
     Lieferwagen in der Versandleiste: Er federt, der Balken wächst sichtbar, der Text springt auf den neuen Betrag.
     Das gilt auch für den Plus-Knopf einer Artikelzeile im Warenkorb (Bild der Zeile fliegt zum Lieferwagen).
  Wer "Bewegung reduzieren" eingestellt hat, bekommt nur Haken und Zähler.
  Hängt sich an das Theme-Ereignis cartUpdate (pubsub.js), das nach erfolgreichem Hinzufügen kommt.
*/
(function () {
  if (window.ncFlyInit) return;
  window.ncFlyInit = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pending = []; // { variantId, button, imgSrc, rect, time }

  // ---------- Bild zum geklickten Button finden ----------
  function findImage(form, button) {
    var scopes = [];
    if (button) scopes.push(button.closest('.dbtfy-toast-container, .sticky-add-to-cart, [class*="sticky"]'));
    scopes.push(form.closest('.card-wrapper, .product-card-wrapper'));
    scopes.push(form.closest('quick-add-modal, .quick-add-modal'));
    scopes.push(form.closest('.shopify-section'));
    scopes.push(document.querySelector('.product__media-wrapper'));
    for (var i = 0; i < scopes.length; i++) {
      var scope = scopes[i];
      if (!scope) continue;
      var imgs = scope.querySelectorAll('.product__media-item.is-active img, .product__media img, .card__media img, img');
      for (var j = 0; j < imgs.length; j++) {
        var r = imgs[j].getBoundingClientRect();
        if (r.width > 24 && r.height > 24 && r.bottom > 0 && r.top < window.innerHeight) {
          return { src: imgs[j].currentSrc || imgs[j].src, rect: r };
        }
      }
    }
    // Ausweichlösung: Bild ist aus dem Bild gescrollt (z. B. mitlaufender Kaufbalken),
    // dann fliegt das Produktbild vom geklickten Button aus los
    var anyImg = document.querySelector('.product__media-wrapper img, .product__media img');
    if (scopes[1]) anyImg = scopes[1].querySelector('img') || anyImg;
    if (anyImg && button) {
      var b = button.getBoundingClientRect();
      var side = Math.min(120, Math.max(60, b.height * 2));
      return {
        src: anyImg.currentSrc || anyImg.src,
        rect: { left: b.left + b.width / 2 - side / 2, top: b.top + b.height / 2 - side / 2, width: side, height: side }
      };
    }
    return null;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.closest || !form.closest('product-form')) return;
    var idInput = form.querySelector('[name="id"]');
    var button = e.submitter || form.querySelector('[type="submit"]');
    var img = findImage(form, button);
    var inCart = !!(button && button.closest('cart-drawer, cart-drawer-items, cart-upsell'));
    var bar = inCart ? visibleDrawerBar() : null;
    var fillEl = bar && bar.querySelector('[data-nc-shipbar-fill]');
    pending.push({
      inCart: inCart,
      prevFill: fillEl ? parseFloat(fillEl.style.width) || 0 : null,
      variantId: idInput ? String(idInput.value) : '',
      button: button,
      imgSrc: img && img.src,
      rect: img && img.rect,
      time: Date.now()
    });
    if (pending.length > 10) pending.shift();
  }, true);

  // ---------- Plus-Knopf im Warenkorb merken ----------
  var plusPending = null; // { imgSrc, rect, prevFill, time }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.quantity__button');
    if (!btn) return;
    var row = btn.closest('.cart-item');
    if (!row || !row.closest('cart-drawer, cart-drawer-items')) return;
    if (btn.name !== 'plus') { plusPending = null; return; }
    var img = row.querySelector('.cart-item__media img, img');
    var bar = visibleDrawerBar();
    var fillEl = bar && bar.querySelector('[data-nc-shipbar-fill]');
    plusPending = img ? {
      imgSrc: img.currentSrc || img.src,
      rect: img.getBoundingClientRect(),
      prevFill: fillEl ? parseFloat(fillEl.style.width) || 0 : null,
      time: Date.now()
    } : null;
  }, true);

  function onCartItemsChanged() {
    var item = plusPending;
    plusPending = null;
    if (!item || Date.now() - item.time > 8000) return;
    var cartPromise = window.ncCart ? window.ncCart.refresh() : null;
    var truck = truckTarget();
    if (reduceMotion || !truck) {
      Promise.resolve(cartPromise).then(updateCount);
      return;
    }
    fly(item.imgSrc, item.rect, truck, function () {
      Promise.resolve(cartPromise).then(function (cart) {
        updateCount(cart);
        truckImpact(item.prevFill);
      });
    }, true);
  }

  // ---------- Haken am Button ----------
  function showCheck(button) {
    if (!button) return;
    var old = button.querySelector('.nc-check');
    if (old) old.remove();
    clearTimeout(button._ncCheckTimer);
    var check = document.createElement('span');
    check.className = 'nc-check';
    check.setAttribute('aria-hidden', 'true');
    check.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22"><path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    button.appendChild(check);
    button.classList.add('nc-added');
    button._ncCheckTimer = setTimeout(function () {
      button.classList.remove('nc-added');
      check.remove();
    }, 1500);
  }

  // ---------- Warenkorb-Symbol finden ----------
  function cartTarget() {
    var links = document.querySelectorAll('#cart-icon-bubble');
    for (var i = 0; i < links.length; i++) {
      var r = links[i].getBoundingClientRect();
      if (r.width > 0 && r.bottom > 0 && r.top < window.innerHeight) return links[i];
    }
    return links[0] || null;
  }

  // ---------- Versandleiste in Schublade oder Warenkorbseite ----------
  function isVisible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight && r.right > 0 && r.left < window.innerWidth;
  }

  function visibleDrawerBar() {
    var bars = document.querySelectorAll('.nc-shipbar--drawer');
    for (var i = 0; i < bars.length; i++) {
      if (isVisible(bars[i])) return bars[i];
    }
    return null;
  }

  function truckTarget() {
    var bar = visibleDrawerBar();
    var truck = bar && bar.querySelector('.nc-shipbar__truck');
    return isVisible(truck) ? truck : null;
  }

  // Die Schublade baut ihren Inhalt nach dem Hinzufügen neu auf, deshalb nach dem Flug frisch suchen
  function truckImpact(prevFill) {
    var bar = visibleDrawerBar();
    if (!bar) return;
    var truck = bar.querySelector('.nc-shipbar__truck');
    if (truck) impact(truck);
    var fill = bar.querySelector('[data-nc-shipbar-fill]');
    var now = fill ? parseFloat(fill.style.width) || 0 : null;
    if (fill && prevFill !== null && now !== prevFill) {
      fill.animate([{ width: prevFill + '%' }, { width: now + '%' }], { duration: 700, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
    }
    bar.classList.remove('is-pop');
    void bar.offsetWidth;
    bar.classList.add('is-pop');
  }

  // ---------- Zähler sofort setzen ----------
  function updateCount(cart) {
    if (!cart) return;
    document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
      var span = bubble.querySelector('span[aria-hidden="true"]');
      if (span && cart.item_count < 100) span.textContent = cart.item_count;
      if (!reduceMotion) {
        bubble.animate(
          [{ transform: 'scale(1)' }, { transform: 'scale(1.7)', offset: 0.35 }, { transform: 'scale(0.9)', offset: 0.7 }, { transform: 'scale(1)' }],
          { duration: 450, easing: 'ease-out' }
        );
      }
    });
  }

  // ---------- Aufprall: Symbol federt, Ring und Funken ----------
  function impact(target) {
    var icon = target.querySelector('.svg-wrapper') || target;
    icon.animate(
      [
        { transform: 'scale(1) rotate(0)' },
        { transform: 'scale(1.45) rotate(-10deg)', offset: 0.25 },
        { transform: 'scale(0.85) rotate(6deg)', offset: 0.55 },
        { transform: 'scale(1.1) rotate(-2deg)', offset: 0.8 },
        { transform: 'scale(1) rotate(0)' }
      ],
      { duration: 560, easing: 'cubic-bezier(0.34, 1.56, 0.64, 1)' }
    );
    var r = icon.getBoundingClientRect();
    var cx = r.left + r.width / 2;
    var cy = r.top + r.height / 2;

    var ring = document.createElement('span');
    ring.className = 'nc-burst-ring';
    ring.style.left = cx + 'px';
    ring.style.top = cy + 'px';
    document.body.appendChild(ring);
    ring.animate(
      [{ transform: 'translate(-50%,-50%) scale(0.3)', opacity: 0.9 }, { transform: 'translate(-50%,-50%) scale(2.2)', opacity: 0 }],
      { duration: 480, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
    ).onfinish = function () { ring.remove(); };

    var colors = ['#de00ae', '#ff7ad9', '#ffc83d', '#de00ae', '#7ad3ff', '#ff7ad9', '#ffc83d', '#de00ae'];
    for (var i = 0; i < 8; i++) {
      var dot = document.createElement('span');
      dot.className = 'nc-burst-dot';
      dot.style.left = cx + 'px';
      dot.style.top = cy + 'px';
      dot.style.background = colors[i];
      document.body.appendChild(dot);
      var angle = (Math.PI * 2 * i) / 8 + Math.random() * 0.4;
      var dist = 22 + Math.random() * 14;
      dot.animate(
        [
          { transform: 'translate(-50%,-50%) scale(1)', opacity: 1 },
          { transform: 'translate(calc(-50% + ' + Math.cos(angle) * dist + 'px), calc(-50% + ' + Math.sin(angle) * dist + 'px)) scale(0.3)', opacity: 0 }
        ],
        { duration: 520, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
      ).onfinish = (function (d) { return function () { d.remove(); }; })(dot);
    }
  }

  // ---------- Flug im Bogen ----------
  function fly(src, rect, target, done, flat) {
    var t = (target.querySelector('.svg-wrapper') || target).getBoundingClientRect();
    var size = Math.max(56, Math.min(110, rect.width * 0.55));
    // Start im sichtbaren Bereich halten (z. B. Karte ragt halb aus dem Slider)
    var x0 = Math.min(Math.max(rect.left + rect.width / 2, size / 2), window.innerWidth - size / 2);
    var y0 = rect.top + rect.height / 2;
    var x2 = t.left + t.width / 2;
    var y2 = t.top + t.height / 2;
    // Kontrollpunkt deutlich oberhalb: das Bild steigt erst auf und stürzt dann in den Warenkorb
    var x1 = x0 + (x2 - x0) * 0.2;
    var y1 = Math.min(y0, y2) - Math.max(140, Math.abs(y0 - y2) * 0.45);
    // Ziel liegt in der Schublade weit oben: Bogen flacher, damit er nicht über den Bildschirmrand schießt
    if (flat) {
      x1 = x0 + (x2 - x0) * 0.5;
      y1 = Math.max(10, Math.min(y0, y2) - 60);
    }

    var el = document.createElement('div');
    el.className = 'nc-fly';
    el.style.width = size + 'px';
    el.style.height = size + 'px';
    el.style.left = (x0 - size / 2) + 'px';
    el.style.top = (y0 - size / 2) + 'px';
    el.innerHTML = '<img alt="" src="' + src + '">';
    document.body.appendChild(el);

    var lift = 150;    // kurzes Anheben
    var flight = 620;  // Flug
    var start = performance.now();

    function frame(now) {
      var ms = now - start;
      var dx, dy, scale, rot;
      if (ms < lift) {
        var a = ms / lift;
        var easeOut = 1 - Math.pow(1 - a, 3);
        dx = 0;
        dy = -14 * easeOut;
        scale = 1 + 0.12 * easeOut;
        rot = -4 * easeOut;
      } else {
        var p = Math.min(1, (ms - lift) / flight);
        // langsam los, dann immer schneller: "reinknallen"
        var u = Math.pow(p, 2.4);
        var bx = (1 - u) * (1 - u) * x0 + 2 * (1 - u) * u * x1 + u * u * x2;
        var by = (1 - u) * (1 - u) * (y0 - 14) + 2 * (1 - u) * u * y1 + u * u * y2;
        dx = bx - x0;
        dy = by - y0;
        scale = 1.12 - 0.94 * u;
        rot = -4 + 22 * u;
        if (p >= 1) {
          el.remove();
          done();
          return;
        }
      }
      el.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(' + scale + ') rotate(' + rot + 'deg)';
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  // ---------- Erfolg nach dem Hinzufügen ----------
  function onAdded(evt) {
    if (evt && evt.source === 'cart-items') { onCartItemsChanged(); return; }
    if (!evt || evt.source !== 'product-form') return;
    var vid = String(evt.productVariantId || '');
    var idx = -1;
    for (var i = 0; i < pending.length; i++) {
      if (Date.now() - pending[i].time < 15000 && (!vid || pending[i].variantId === vid)) { idx = i; break; }
    }
    var item = idx >= 0 ? pending.splice(idx, 1)[0] : null;

    if (item) showCheck(item.button);

    var cartPromise = window.ncCart ? window.ncCart.refresh() : fetch('/cart.js').then(function (r) { return r.json(); });
    var truck = item && item.inCart ? truckTarget() : null;
    var target = truck || cartTarget();

    if (reduceMotion || !item || !item.imgSrc || !item.rect || !target) {
      Promise.resolve(cartPromise).then(updateCount);
      return;
    }
    fly(item.imgSrc, item.rect, target, function () {
      if (truck) {
        Promise.resolve(cartPromise).then(function (cart) {
          updateCount(cart);
          truckImpact(item.prevFill);
        });
      } else {
        impact(target);
        Promise.resolve(cartPromise).then(updateCount);
      }
    }, !!truck);
  }

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, onAdded);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
